import axios from "axios"
import GlobalVariable from "./global"
import { isUserLoggedIn } from "../utility/Utils"
const baseApiUrl = GlobalVariable.BASE_API_URL
const headerText = GlobalVariable.headerText

const DocusignTitle = 'You have received an email attachment from DocuSign. Please review and sign the document.'
const InvoicePaymentModes = [{ value: 1, label: 'WireTransfer' }, { value: 2, label: 'CreditCard' }, { value: 3, label: 'PayLater' }, { value: 4, label: 'GPay' }, { value: 5, label: 'ApplePay' }]
const InvoicePaymentStatus = [{ value: 1, label: 'Pending' }, { value: 2, label: 'Processed' }, { value: 3, label: 'Failed' }]
const WOStatus = [{ value: 1, label: 'Active' }, { value: 2, label: 'Cancelled' }, { value: 3, label: 'Archived' }]
const errorresponse = "Something Went Wrong. Please approach technical team."
const datesList = ["st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "st"]
const monthnames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const fullmonthnames = [
  { key: '01', value: 'Jan' },
  { key: '02', value: 'Feb' },
  { key: '03', value: 'Mar' },
  { key: '04', value: 'Apr' },
  { key: '05', value: 'May' },
  { key: '06', value: 'Jun' },
  { key: '07', value: 'Jul' },
  { key: '08', value: 'Aug' },
  { key: '09', value: 'Sep' },
  { key: '10', value: 'Oct' },
  { key: '11', value: 'Nov' },
  { key: '12', value: 'Dec' }
]
const PaymentInstructions = `<div>
<div class="payment-instructions">PAYMENT INSTRUCTIONS</div>
<div class="wire-transfer-info">
<span class="wire-transfer-title">WIRE TRANSFER:</span>
<span class="wire-transfer-description">Please remit payment to one of the following bank accounts.</span>
</div>
<div class="bank-accounts">
<div class="bank-details">
<div class="bank-column">
<div class="bank-row">
<span class="bank-label">Bank Name:</span>
<span class="bank-info">Bank of America N.A. McLean, VA 22102, USA</span>
</div>
<div class="bank-row">
<span class="bank-label">Swift Code:</span>
<span class="bank-info">BOFAUS3N</span>
</div>
<div class="bank-row">
<span class="bank-label">Routing #:</span>
<span class="bank-info">026009593</span>
</div>
<div class="bank-row">
<span class="bank-label">Account Name:</span>
<span class="bank-info">LISCR,LLC - Maritime</span>
</div>
<div class="bank-row">
<span class="bank-label">Account #:</span>
<span class="bank-info">435059558880</span>
</div>
</div>
<div class="bank-column">
<div class="bank-row">
<span class="bank-label">Bank Name:</span>
<span class="bank-info">JPMorgan Chase, New York, NY 10017, USA</span>
</div>
<div class="bank-row">
<span class="bank-label">Swift Code:</span>
<span class="bank-info">CHASUS33</span>
</div>
<div class="bank-row">
<span class="bank-label">Routing #:</span>
<span class="bank-info">021000021</span>
</div>
<div class="bank-row">
<span class="bank-label">Account Name:</span>
<span class="bank-info">LISCR,LLC - Maritime</span>
</div>
<div class="bank-row">
<span class="bank-label">Account #:</span>
<span class="bank-info">826835669</span>
</div>
</div>
</div>
</div>
<div class="payment-bottom-space"></div>
</div>`

// const refreshAccessToken = async () => {
//   const savedState = localStorage.getItem("azureAdB2C")
//   const b2cData = JSON.parse(savedState)
//   const formData = new FormData()
//   formData.append('client_id', b2cData.clientId)
//   formData.append('refresh_token', localStorage.getItem("refresh_token"))
//   formData.append('grant_type', 'refresh_token')
//   formData.append('code_verifier', b2cData.codeVerifier)
//   formData.append('redirect_uri', b2cData.hostname)
//   return axios.post(`${b2cData.instance}/${b2cData.domain}/oauth2/v2.0/token?p=${b2cData.signUpSignInPolicyId}`, formData).then(res => {
//     localStorage.setItem("token", res.data.id_token)
//     localStorage.setItem("refresh_token", res.data.refresh_token)
//     return res.data.id_token
//   })
// }

const regionalOffices = [
  { id: 1, label: "Argentina", value: "Argentina", name: "Argentina", isActive: 1 },
  { id: 2, label: "Brazil", value: "Brazil", name: "Brazil", isActive: 1 },
  { id: 3, label: "China", value: "China", name: "China", isActive: 1 },
  { id: 4, label: "Dubai", value: "Dubai", name: "Dubai", isActive: 1 },
  { id: 5, label: "Greece", value: "Greece", name: "Greece", isActive: 1 },
  { id: 6, label: "Hamburg", value: "Hamburg", name: "Hamburg", isActive: 1 },
  { id: 7, label: "Hongkong", value: "Hongkong", name: "Hongkong", isActive: 1 },
  { id: 8, label: "Japan", value: "Japan", name: "Japan", isActive: 1 },
  { id: 9, label: "Korea", value: "Korea", name: "Korea", isActive: 1 },
  { id: 10, label: "Leer", value: "Leer", name: "Leer", isActive: 1 },
  { id: 11, label: "London", value: "London", name: "London", isActive: 1 },
  { id: 12, label: "Manila", value: "Manila", name: "Manila", isActive: 1 },
  { id: 13, label: "Panama", value: "Panama", name: "Panama", isActive: 1 },
  { id: 14, label: "Philippines", value: "Philippines", name: "Philippines", isActive: 1 },
  { id: 15, label: "Piraeus", value: "Piraeus", name: "Piraeus", isActive: 1 },
  { id: 16, label: "Shanghai", value: "Shanghai", name: "Shanghai", isActive: 1 },
  { id: 17, label: "Singapore", value: "Singapore", name: "Singapore", isActive: 1 },
  { id: 18, label: "South Korea", value: "South Korea", name: "South Korea", isActive: 1 },
  { id: 19, label: "Taiwan", value: "Taiwan", name: "Taiwan", isActive: 1 },
  { id: 20, label: "Turkey", value: "Turkey", name: "Turkey", isActive: 1 },
  { id: 21, label: "USA", value: "USA", name: "USA", isActive: 1 }
]
const addResponseInterceptor = async (axiosInstance) => {
  axiosInstance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      const access_token = error.response.headers['x-auth-token']
      const refresh_token = error.response.headers['x-refresh-token']
      localStorage.setItem("token", access_token)
      localStorage.setItem("refresh_token", refresh_token)
      originalRequest.headers['Authorization'] = `Bearer ${access_token}`
      return axiosInstance(originalRequest)
    }
    return Promise.reject(error)
  })
}

export const DefaultConfig = () => {
  let authAxios
  let authAxiosMulti
  if (localStorage.getItem("userData")) {
    const localStorageToken = localStorage.getItem('token')
    const refreshToken = localStorage.getItem('refresh_token')
    authAxios = axios.create({
      baseURL: baseApiUrl,
      headers: { Authorization: `Bearer ${localStorageToken}`, "x-refresh-token": refreshToken },
      withCredentials: true
    })
    addResponseInterceptor(authAxios)
    authAxiosMulti = axios.create({
      baseURL: baseApiUrl,
      headers: {
        Authorization: `Bearer ${localStorageToken}`,
        "Content-Type": "multipart/form-data",
        "x-refresh-token": refreshToken
      },
      withCredentials: true

    })
    addResponseInterceptor(authAxiosMulti)
  }

  const sorter = (sortname, sortorder, filteredData) => {
    const sortData = filteredData
    sortData.sort((a, b) => {
      if (typeof a[sortname] === "number" && typeof b[sortname] === "number") {
        if (sortorder === "asc") {
          return parseInt(a[sortname]) > parseInt(b[sortname]) ? 1 : parseInt(a[sortname]) < parseInt(b[sortname]) ? -1 : 0
        } else {
          return parseInt(b[sortname]) > parseInt(a[sortname]) ? 1 : parseInt(b[sortname]) < parseInt(a[sortname]) ? -1 : 0
        }
      } else if (
        typeof a[sortname] === "string" && typeof b[sortname] === "string") {
        if (sortorder === "asc") {
          return a[sortname].toLowerCase() > b[sortname].toLowerCase() ? 1 : a[sortname].toLowerCase() < b[sortname].toLowerCase() ? -1 : 0
        } else {
          return b[sortname].toLowerCase() > a[sortname].toLowerCase() ? 1 : b[sortname].toLowerCase() < a[sortname].toLowerCase() ? -1 : 0
        }
      } else {
        if (sortorder === "asc") {
          return a[sortname] > b[sortname] ? 1 : a[sortname] < b[sortname] ? -1 : 0
        } else {
          return b[sortname] > a[sortname] ? 1 : b[sortname] < a[sortname] ? -1 : 0
        }
      }
    })
    return sortData
  }

  const ReplaceString = (value) => {
    if (value) {
      return new Date(value.replace(/(\d+)(st|nd|rd|th)/, '$1'))
    }
    return ''
  }

  const DateFormat = (value) => {
    if (value) {
      const monthname = monthnames[new Date(value).getMonth()]
      const datevalue = `0${new Date(value).getDate()}`.slice(-2)
      const yearvalue = new Date(value).getFullYear()
      return `${datevalue} ${monthname} ${yearvalue}`
    } else {
      return ""
    }
  }

  const getThreeLetterTimeZone = () => {
    const dateString = new Date().toString()
    const match = dateString.match(/\(([A-Za-z\s].*)\)/)
    if (match && match.length > 1) {
      const abbreviation = match[1].split(' ').map(word => word[0]).join('')
      return abbreviation
    }
    return "Unknown Time Zone"
  }

  const frpRoleColor = (roleName) => {
    let color = ''
    if (roleName === 'ISM') {
      color = 'red'
    } else if (roleName === 'ISPS') {
      color = 'green'
    } else if (roleName === 'Miscellaneous Billing') {
      color = '#b1b100'
    } else if (roleName === 'Tonnage') {
      color = 'blue'
    }
    return color
  }

  const StringtoDateMonthYearFormat = (valueDate) => {
    if (valueDate) {
      const splitString = valueDate.split("-")
      if (splitString.length === 3) {
        const datevalue = splitString[0]
        const findMonth = fullmonthnames.find(find => find.key === splitString[1])
        let monthname = ''
        if (findMonth) {
          monthname = findMonth.value
        }
        const yearvalue = splitString[2]
        return `${datevalue}-${monthname}-${yearvalue}`
      }
    }
    return ""
  }

  const YearMonthDateFormat = (value) => {
    if (value) {
      // const splitDateFormat = value.split("T")
      // const splitDate = splitDateFormat.length > 0 ? splitDateFormat[0] : ''
      // if (splitDate) {
      //   const splitString = splitDate.split("-")
      //   if (splitString.length === 3) {
      //     const yearvalue = splitString[0]
      //     const findMonth = fullmonthnames.find(find => find.key === splitString[1])
      //     let monthname = ''
      //     if (findMonth) {
      //       monthname = findMonth.value
      //     }
      //     const datevalue = splitString[2]
      //     return `${monthname} ${datevalue && datevalue.replace(/^0/, '')}${datesList[datevalue - 1]}, ${yearvalue}`
      //   }
      // }
      const date = new Date(value)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ""
  }

  const optionAdrress = [{ value: "Primary Address", label: "Primary Address", id: 1 }, { value: "Shipping Address", label: "Shipping Address", id: 2 }, { value: "Billing Address", label: "Billing Address", id: 3 }]

  const DateConversion = (dateStr) => {
    if (dateStr) {
      // Create a Date object from the input string
      const date = new Date(dateStr)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ''
    // if (dateStr) {
    //   // Convert to Date object
    //   const date = new Date(dateStr)

    //   // Custom function to add ordinal suffix
    //   function addOrdinalSuffix(day) {
    //     if (day >= 11 && day <= 13) {
    //       return `${day}th`
    //     }

    //     const lastDigit = day % 10
    //     switch (lastDigit) {
    //       case 1:
    //         return `${day}st`
    //       case 2:
    //         return `${day}nd`
    //       case 3:
    //         return `${day}rd`
    //       default:
    //         return `${day}th`
    //     }
    //   }

    //   // Format date and time
    //   const formattedDate = date.toLocaleDateString("en-US", {
    //     month: "short",
    //     day: "numeric",
    //     year: "numeric"
    //   })

    //   // Extract day from the formatted date
    //   const day = formattedDate.match(/\d+/)[0]

    //   // Add ordinal suffix to the day
    //   const ordinalDay = addOrdinalSuffix(day)

    //   // Combine the formatted date, ordinal day, and formatted time
    //   const formattedDateTime = `${formattedDate.replace(/\d+/, ordinalDay)}`
    //   return formattedDateTime
    // }
    // return ''
  }

  const DateTimeConversion = (dateStr) => {
    if (dateStr) {
      // // Convert to Date object
      // const date = new Date(dateStr)

      // // Custom function to add ordinal suffix
      // function addOrdinalSuffix(day) {
      //   if (day >= 11 && day <= 13) {
      //     return `${day}th`
      //   }

      //   const lastDigit = day % 10
      //   switch (lastDigit) {
      //     case 1:
      //       return `${day}st`
      //     case 2:
      //       return `${day}nd`
      //     case 3:
      //       return `${day}rd`
      //     default:
      //       return `${day}th`
      //   }
      // }

      // // Format date and time
      // const formattedDate = date.toLocaleDateString("en-US", {
      //   month: "short",
      //   day: "numeric",
      //   year: "numeric"
      // })
      // const formattedTime = date.toLocaleTimeString("en-US", {
      //   hour: '2-digit', minute: '2-digit', second: '2-digit'
      // })

      // // Extract day from the formatted date
      // const day = formattedDate.match(/\d+/)[0]

      // // Add ordinal suffix to the day
      // const ordinalDay = addOrdinalSuffix(day)

      // // Combine the formatted date, ordinal day, and formatted time
      // const formattedDateTime = `${formattedDate.replace(/\d+/, ordinalDay)} ${formattedTime}`
      // return formattedDateTime

      // Create a Date object from the input string
      const date = new Date(dateStr)
      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      const formattedTime = date.toLocaleTimeString("en-US", {
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      })
      const formattedDateTime = `${formattedDate} ${formattedTime}`

      return formattedDateTime
    }
    return ''
  }

  const formattedDateIssueFixed = (data) => {
    if (data) {
      const date = new Date(data)
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      const day = date.getUTCDate()
      const month = months[date.getUTCMonth()]
      const year = date.getUTCFullYear()
      const formattedDate = `${day} ${month} ${year}`
      return formattedDate
    }
  }

  const AmountFormat = (amount) => {
    if (isNaN(amount)) {
      return ''
    }
    let x = Number.parseFloat(amount).toFixed(2)
    const sign = x.startsWith('-') ? '-' : ''
    x = x.replace('-', '')
    const parts = x.split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return sign + parts.join('.')
  }

  const selectStyles = {
    menuPortal: (provided) => ({
      ...provided,
      height: 200,
      zIndex: 9999
    }),
    container: (provided) => ({
      ...provided,
      marginTop: 0
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: "visible"
    }),
    placeholder: (base, state) => ({
      ...base,
      position: "absolute",
      top: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) ? '-45%' : '20%',
      transition: 'top 0.2s, font-size 0.2s',
      fontSize: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) && 14,
      background: "#fff !important",
      padding: "0 5px",

      fontWeight: 500,
      color: '#000'
    })
  }
  const selectStyles1 = {
    menu: base => ({
      ...base,
      top: 0,
      zIndex: 9999
    }),
    menuPortal: (provided) => ({
      ...provided,
      height: 200,
      zIndex: 9999
    }),
    container: (provided) => ({
      ...provided,
      marginTop: 0
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: "visible"
    }),
    placeholder: (base, state) => ({
      ...base,
      position: "absolute",
      top: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) ? '-45%' : '20%',
      transition: 'top 0.2s, font-size 0.2s',
      fontSize: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) && 14,
      background: "#fff !important",
      padding: "0 5px",

      fontWeight: 500,
      color: '#000'
    })
  }
  const formatYearDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }
  const emailDurationTime = 30 * 1000
  const zoomInOut = { animate: { opacity: 1, scale: 1 }, transition: { duration: 1, delay: 0.1 }, initial: { opacity: 0, scale: 0.5 }, exit: { opacity: 0, scale: 0.5 } }
  const leftToRight = { animate: { x: 0 }, transition: { type: 'slide', stiffness: 120 }, initial: { x: '-100%' }, exit: { x: '100%' } }
  const CreditCardpercentage = 0.04
  const CreditCardNote = 'Please note that a 4% Convenience Fee is charged based on the transaction total'

  function DepartmentMapping(data) {
    const Data = [
      { id: -1, name: "DEFAULT" },
      { id: 1, name: "SCD-COURSE" },
      { id: 2, name: "SCD-DRAWDOWN" },
      { id: 3, name: "SCD-SEAFARER" },
      { id: 4, name: "SCD-SEASYSTEM" },
      { id: 5, name: "CORPORATE" },
      { id: 6, name: "MARITIME" },
      { id: 7, name: "TRUST" },
      { id: 8, name: "MARITIMEENT" },
      { id: 9, name: "SCD-3RD PARTY" },
      { id: 10, name: "SEA SERVE" },
      { id: 11, name: "SCD-INVOICE" },
      { id: 12, name: "SCD-PREPAYMENT" }
    ]
    if (data === undefined) {
      return Data.map(item => ({
        label: item.name,
        value: item.name,
        id: item.id
      }))
    }
    const tempData = Data.find((item) => item.id === Number(data))
    return tempData ? tempData.name : ""
  }

  function SourceSystem(data) {
    const portals = [
      { id: 1, value: "Default", label: "Default", code: "DFT", isActive: true },
      { id: 2, value: "Publications", label: "Publications", code: "PUB", isActive: true },
      { id: 3, value: "SCD", label: "SCD", code: "SCD", isActive: true },
      { id: 4, value: "WayPoint", label: "WayPoint", code: "WP", isActive: true },
      { id: 5, value: "WayPoint Cloud", label: "WayPoint Cloud", code: "WPC", isActive: true },
      { id: 6, value: "Client Portal", label: "Client Portal", code: "CL", isActive: true },
      { id: 7, value: "Corporate Portal", label: "Corporate Portal", code: "CO", isActive: true },
      { id: 8, value: "Accounting Portal", label: "Accounting Portal", code: "AC", isActive: true },
      { id: 9, value: "Seafarer Portal", label: "Seafarer Portal", code: "SFR", isActive: true }
    ]
    if (data === "options") {
      return portals
    }
    const result = portals.find((item) => item.id === Number(data))
    return result?.value ? result : null
  }

  const ShownImportCompanyBtn = () => {
    if (isUserLoggedIn()) {
      const parsedData = JSON.parse(isUserLoggedIn())
      const roles = parsedData?.userRoles

      if (roles.some(role => role.roleId === 1 || role.roleId === 5 || role.roleId === 3)) {
        return true
      }
    }
    return false
  }

  const UserWriterRole = () => {
    if (isUserLoggedIn()) {
      const parsedData = JSON.parse(isUserLoggedIn())
      const roles = parsedData?.userRoles

      if (roles.some(role => role.roleId === 1 || role.roleId === 3 || role.roleId === 5)) {
        return true
      }
    }
    return false
  }

  const VesselWriterRole = () => {
    if (isUserLoggedIn()) {
      const parsedData = JSON.parse(isUserLoggedIn())
      const roles = parsedData?.userRoles

      if (roles.some(role => role.roleId === 1 || role.roleId === 7)) {
        return true
      }
    }
    return false
  }

  return {
    headerText,
    DepartmentMapping,
    SourceSystem,
    selectStyles,
    selectStyles1,
    DocusignTitle,
    InvoicePaymentModes,
    InvoicePaymentStatus,
    WOStatus,
    errorresponse,
    authAxios,
    authAxiosMulti,
    PaymentInstructions,
    sorter,
    datesList,
    monthnames,
    DateFormat,
    getThreeLetterTimeZone,
    YearMonthDateFormat,
    AmountFormat,
    formattedDateIssueFixed,
    StringtoDateMonthYearFormat,
    regionalOffices,
    DateTimeConversion,
    optionAdrress,
    DateConversion,
    ReplaceString,
    emailDurationTime,
    zoomInOut,
    leftToRight,
    formatYearDate,
    CreditCardpercentage,
    CreditCardNote,
    frpRoleColor,
    ShownImportCompanyBtn,
    UserWriterRole,
    VesselWriterRole
  }
}
